import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/random/streams/arcsine';
import __var_2__ from '@stdlib/random/streams/bernoulli';
import __var_3__ from '@stdlib/random/streams/beta';
import __var_4__ from '@stdlib/random/streams/betaprime';
import __var_5__ from '@stdlib/random/streams/binomial';
import __var_6__ from '@stdlib/random/streams/box-muller';
import __var_7__ from '@stdlib/random/streams/cauchy';
import __var_8__ from '@stdlib/random/streams/chi';
import __var_9__ from '@stdlib/random/streams/chisquare';
import __var_10__ from '@stdlib/random/streams/cosine';
import __var_11__ from '@stdlib/random/streams/discrete-uniform';
import __var_12__ from '@stdlib/random/streams/erlang';
import __var_13__ from '@stdlib/random/streams/exponential';
import __var_14__ from '@stdlib/random/streams/f';
import __var_15__ from '@stdlib/random/streams/frechet';
import __var_16__ from '@stdlib/random/streams/gamma';
import __var_17__ from '@stdlib/random/streams/geometric';
import __var_18__ from '@stdlib/random/streams/gumbel';
import __var_19__ from '@stdlib/random/streams/hypergeometric';
import __var_20__ from '@stdlib/random/streams/improved-ziggurat';
import __var_21__ from '@stdlib/random/streams/invgamma';
import __var_22__ from '@stdlib/random/streams/kumaraswamy';
import __var_23__ from '@stdlib/random/streams/laplace';
import __var_24__ from '@stdlib/random/streams/levy';
import __var_25__ from '@stdlib/random/streams/logistic';
import __var_26__ from '@stdlib/random/streams/lognormal';
import __var_27__ from '@stdlib/random/streams/minstd';
import __var_28__ from '@stdlib/random/streams/minstd-shuffle';
import __var_29__ from '@stdlib/random/streams/mt19937';
import __var_30__ from '@stdlib/random/streams/negative-binomial';
import __var_31__ from '@stdlib/random/streams/normal';
import __var_32__ from '@stdlib/random/streams/pareto-type1';
import __var_33__ from '@stdlib/random/streams/poisson';
import __var_34__ from '@stdlib/random/streams/randi';
import __var_35__ from '@stdlib/random/streams/randn';
import __var_36__ from '@stdlib/random/streams/randu';
import __var_37__ from '@stdlib/random/streams/rayleigh';
import __var_38__ from '@stdlib/random/streams/t';
import __var_39__ from '@stdlib/random/streams/triangular';
import __var_40__ from '@stdlib/random/streams/uniform';
import __var_41__ from '@stdlib/random/streams/weibull';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name arcsine
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/arcsine}
*/
setReadOnly( ns, 'arcsine', __var_1__);

/**
* @name bernoulli
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/bernoulli}
*/
setReadOnly( ns, 'bernoulli', __var_2__);

/**
* @name beta
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/beta}
*/
setReadOnly( ns, 'beta', __var_3__);

/**
* @name betaprime
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/betaprime}
*/
setReadOnly( ns, 'betaprime', __var_4__);

/**
* @name binomial
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/binomial}
*/
setReadOnly( ns, 'binomial', __var_5__);

/**
* @name boxMuller
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/box-muller}
*/
setReadOnly( ns, 'boxMuller', __var_6__);

/**
* @name cauchy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/cauchy}
*/
setReadOnly( ns, 'cauchy', __var_7__);

/**
* @name chi
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/chi}
*/
setReadOnly( ns, 'chi', __var_8__);

/**
* @name chisquare
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/chisquare}
*/
setReadOnly( ns, 'chisquare', __var_9__);

/**
* @name cosine
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/cosine}
*/
setReadOnly( ns, 'cosine', __var_10__);

/**
* @name discreteUniform
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/discrete-uniform}
*/
setReadOnly( ns, 'discreteUniform', __var_11__);

/**
* @name erlang
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/erlang}
*/
setReadOnly( ns, 'erlang', __var_12__);

/**
* @name exponential
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/exponential}
*/
setReadOnly( ns, 'exponential', __var_13__);

/**
* @name f
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/f}
*/
setReadOnly( ns, 'f', __var_14__);

/**
* @name frechet
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/frechet}
*/
setReadOnly( ns, 'frechet', __var_15__);

/**
* @name gamma
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/gamma}
*/
setReadOnly( ns, 'gamma', __var_16__);

/**
* @name geometric
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/geometric}
*/
setReadOnly( ns, 'geometric', __var_17__);

/**
* @name gumbel
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/gumbel}
*/
setReadOnly( ns, 'gumbel', __var_18__);

/**
* @name hypergeometric
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/hypergeometric}
*/
setReadOnly( ns, 'hypergeometric', __var_19__);

/**
* @name improvedZiggurat
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/improved-ziggurat}
*/
setReadOnly( ns, 'improvedZiggurat', __var_20__);

/**
* @name invgamma
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/invgamma}
*/
setReadOnly( ns, 'invgamma', __var_21__);

/**
* @name kumaraswamy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/kumaraswamy}
*/
setReadOnly( ns, 'kumaraswamy', __var_22__);

/**
* @name laplace
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/laplace}
*/
setReadOnly( ns, 'laplace', __var_23__);

/**
* @name levy
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/levy}
*/
setReadOnly( ns, 'levy', __var_24__);

/**
* @name logistic
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/logistic}
*/
setReadOnly( ns, 'logistic', __var_25__);

/**
* @name lognormal
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/lognormal}
*/
setReadOnly( ns, 'lognormal', __var_26__);

/**
* @name minstd
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/minstd}
*/
setReadOnly( ns, 'minstd', __var_27__);

/**
* @name minstdShuffle
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/minstd-shuffle}
*/
setReadOnly( ns, 'minstdShuffle', __var_28__);

/**
* @name mt19937
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/mt19937}
*/
setReadOnly( ns, 'mt19937', __var_29__);

/**
* @name negativeBinomial
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/negative-binomial}
*/
setReadOnly( ns, 'negativeBinomial', __var_30__);

/**
* @name normal
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/normal}
*/
setReadOnly( ns, 'normal', __var_31__);

/**
* @name pareto1
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/pareto-type1}
*/
setReadOnly( ns, 'pareto1', __var_32__);

/**
* @name poisson
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/poisson}
*/
setReadOnly( ns, 'poisson', __var_33__);

/**
* @name randi
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/randi}
*/
setReadOnly( ns, 'randi', __var_34__);

/**
* @name randn
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/randn}
*/
setReadOnly( ns, 'randn', __var_35__);

/**
* @name randu
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/randu}
*/
setReadOnly( ns, 'randu', __var_36__);

/**
* @name rayleigh
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/rayleigh}
*/
setReadOnly( ns, 'rayleigh', __var_37__);

/**
* @name t
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/t}
*/
setReadOnly( ns, 't', __var_38__);

/**
* @name triangular
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/triangular}
*/
setReadOnly( ns, 'triangular', __var_39__);

/**
* @name uniform
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/uniform}
*/
setReadOnly( ns, 'uniform', __var_40__);

/**
* @name weibull
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/random/streams/weibull}
*/
setReadOnly( ns, 'weibull', __var_41__);


// EXPORTS //
export default ns;

export { __var_1__ as arcsine, __var_2__ as bernoulli, __var_3__ as beta, __var_4__ as betaprime, __var_5__ as binomial, __var_6__ as boxMuller, __var_7__ as cauchy, __var_8__ as chi, __var_9__ as chisquare, __var_10__ as cosine, __var_11__ as discreteUniform, __var_12__ as erlang, __var_13__ as exponential, __var_14__ as f, __var_15__ as frechet, __var_16__ as gamma, __var_17__ as geometric, __var_18__ as gumbel, __var_19__ as hypergeometric, __var_20__ as improvedZiggurat, __var_21__ as invgamma, __var_22__ as kumaraswamy, __var_23__ as laplace, __var_24__ as levy, __var_25__ as logistic, __var_26__ as lognormal, __var_27__ as minstd, __var_28__ as minstdShuffle, __var_29__ as mt19937, __var_30__ as negativeBinomial, __var_31__ as normal, __var_32__ as pareto1, __var_33__ as poisson, __var_34__ as randi, __var_35__ as randn, __var_36__ as randu, __var_37__ as rayleigh, __var_38__ as t, __var_39__ as triangular, __var_40__ as uniform, __var_41__ as weibull};